<!--
 * @Author: your name
 * @Date: 2021-08-26 17:15:19
 * @LastEditTime: 2022-09-22 18:12:42
 * @LastEditTime: 2021-08-30 16:53:11
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-business\stock\out\index.vue
-->
<template>
  <div class="app-container">
    <BjRouteTabs />
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="false"
      :before-reset-search="beforeResetSearch"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('form.oddNumbers')" prop="queryCode">
            <BjInputCode
              v-model="queryParams.queryCode"
              :placeholder="$t('BusinessStockEntryResult.header.queryCodeText')"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <BjSelectChannelStore
          :span="colSpan"
          :query-params="queryParams"
          :query-props="['channelTypeCode', 'storeIdList']"
          store-option-value="id"
          multiple
        />
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockEntryResult.header.status')" prop="status">
            <BjSelectLov v-model="queryParams.status" lov-code="STOCK.INPUT_STATUS" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockEntryResult.header.receivingLogicWarehouseCode')" prop="receivingLogicWarehouseCode">
            <BjInput
              v-model="queryParams.receivingLogicWarehouseCode"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('BusinessStockEntryResult.header.receivingLogicWarehouseCodeText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.createTimeText')" prop="beginCreationDate">
            <BjDateTimerangePicker v-model="queryParamsTime" :placeholder="$t('table.createTimeText')"/>
          </el-form-item>
        </el-col>
      </template>
      <!-- <template v-slot:tableOperation>
        <el-col>
            <el-button type="primary" >按 钮</el-button>
          </el-col>
        </div>
      </template> -->
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <div v-if="['code', 'warehouseWarrantCode'].includes(col.prop)">
                <span class="link" @click="onView(scope.row, col.prop)">
                  {{ scope.row[col.prop] }}
                </span>
                <BjCopyIcon class="ml10" :copy="scope.row[col.prop]" />
              </div>
              <template v-else-if="col.prop === 'statusMeaning'">
                {{ STOCK_INPUT_STATUS.bjGet(scope.row[col.prop]) }}</template
              >
              <template v-else-if="col.prop === 'inputTypeMeaning'">
                {{ STOCK_INPUT_TYPE.bjGet(scope.row[col.prop]) }}</template
              >
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="props">
              <el-button type="text" >按钮</el-button>
            </template>
          </el-table-column> -->
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { stockApi } from '@/api';
export default {
  name: 'BusinessStockEntryResultIndex',
  components: {},
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 8,
      queryApi: stockApi.getEntryResult,
      // 查询参数
      queryParams: {
        queryCode: null,
        channelTypeCode: null,
        storeIdList: [],
        receivingLogicWarehouseCode: null,
        beginCreationDate: null,
        endCreationDate: null,
        status: null,
      },
      queryParamsTime: null,
      labelsVersion: 11,
      labelList: [
        { label: 'BusinessStockEntryResult.table.code', prop: 'code', isCheck: true, disabled: false, width: '200' },
        {
          label: 'BusinessStockEntryResult.table.warehouseWarrantCode',
          prop: 'warehouseWarrantCode',
          isCheck: true,
          disabled: false,
          width: '210',
        },
        { label: 'BusinessStockEntryResult.table.inputTypeMeaning', prop: 'inputTypeMeaning', isCheck: true, disabled: false, width: '140' },
        { label: 'BusinessStockEntryResult.table.statusMeaning', prop: 'statusMeaning', isCheck: true, disabled: false, width: '140' },
        {
          label: 'BusinessStockEntryResult.table.alreadyQty',
          prop: 'alreadyQty',
          isCheck: true,
          disabled: false,
          width: '170',
        },
        {
          label: 'BusinessStockEntryResult.table.receivingLogicWarehouseCode',
          prop: 'receivingLogicWarehouseCode',
          isCheck: true,
          disabled: false,
          width: '220',
        },
        {
          label: 'BusinessStockEntryResult.table.receivingLogicWarehouseName',
          prop: 'receivingLogicWarehouseName',
          isCheck: true,
          disabled: false,
          width: '230',
        },
        { label: 'BusinessStockEntryResult.table.storeName', prop: 'storeName', isCheck: true, disabled: false, width: '100' },
        { label: 'BusinessStockEntryResult.table.channelTypeCodeMeaning', prop: 'channelTypeCodeMeaning', isCheck: true, disabled: false, width: '120'},
        { label: 'table.createTimeText', prop: 'creationDate', isCheck: true, disabled: false, width: '120' },
        // { label: '操作', prop: 'bjTableAction', isCheck: true, disabled: true, width: 129},
      ],
    };
  },
  computed: {
    STOCK_INPUT_RESULT_STATUS() {
      return this.$store.state.values.STOCK_INPUT_RESULT_STATUS || [];
    },
    STOCK_INPUT_TYPE() {
      return this.$store.state.values.STOCK_INPUT_TYPE || [];
    },
    STOCK_INPUT_STATUS() {
      return this.$store.state.values.STOCK_INPUT_STATUS || [];
    },
  },
  watch: {
    queryParamsTime(v) {
      this.queryParams.beginCreationDate = (v || [])[0];
      this.queryParams.endCreationDate = (v || [])[1];
    },
  },
  created() {},
  mounted() {
    this.$store.dispatch('values/getValueList', 'STOCK.INPUT_RESULT_STATUS');
    this.$store.dispatch('values/getValueList', 'STOCK.INPUT_TYPE');
    this.$store.dispatch('values/getValueList', 'STOCK.INPUT_STATUS');
  },
  methods: {
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParams.storeIdList = null;
      this.queryParamsTime = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    /** 跳转 */
    onView(row, type) {
      /** 结果单详情 */
      if (type === 'code') {
        this.$toBusinessStockEntryResultView(row[type]);
      }
      /** 通知单详情 */
      if (type === 'warehouseWarrantCode') {
        this.$toBusinessStockEntryInformView(row[type]);
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
